import { Flex, View, Image, Text, useTheme } from "@aws-amplify/ui-react";

export function Header() {
  const { tokens } = useTheme();

  return (
    <Flex justifyContent={"center"}>
        <Image
          alt="logo"
          src="https://adly-campaigns.s3.eu-north-1.amazonaws.com/dly-dlogo3.png"
          padding={tokens.space.large}
          height={160}
        />

    </Flex>
  );
}
